/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 修改我的个人资料(头像、性别、昵称、生日、城市、兴趣)
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  userInformationDTO: member.UserInformationDTO,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.UserInformationRes;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "put",
    url: `/member/setting/personal/data`,
    data: userInformationDTO,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
